import { render, staticRenderFns } from "./gymJump.vue?vue&type=template&id=5d984fb4&"
import script from "./gymJump.js?vue&type=script&lang=js&"
export * from "./gymJump.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports